"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _caret_icon = _interopRequireDefault(require("./assets/caret_icon.svg"));
var _FlexBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/FlexBox"));
var _colors = require("baseStyles/enums/colors");
require("./styles.scss");
var _styles2 = _interopRequireDefault(require("./styles"));
var _PositionBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/PositionBox"));
var _excluded = ["children"],
  _excluded2 = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ScrollerContext = /*#__PURE__*/_react["default"].createContext({});
var Scroller = function Scroller(_ref) {
  var onScrollChange = _ref.onScrollChange,
    children = _ref.children,
    refreshDependency = _ref.refreshDependency;
  var scrollableViewRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasNext = _useState2[0],
    setHasNext = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasPrev = _useState4[0],
    setHasPrev = _useState4[1];
  var scrollTimeoutRef = (0, _react.useRef)(null);
  var scrollLeftValue = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    checkScrollState();
  }, [refreshDependency]);
  var scroll = function scroll(val) {
    try {
      if (hasNext || hasPrev) {
        var _scrollableViewRef$cu, _scrollableViewRef$cu2;
        var width = ((_scrollableViewRef$cu = scrollableViewRef.current) === null || _scrollableViewRef$cu === void 0 ? void 0 : _scrollableViewRef$cu.clientWidth) - 50;
        (_scrollableViewRef$cu2 = scrollableViewRef.current) === null || _scrollableViewRef$cu2 === void 0 || _scrollableViewRef$cu2.scrollBy({
          left: width * val,
          behavior: 'smooth'
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  var checkScrollState = function checkScrollState(event) {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }
    scrollTimeoutRef.current = setTimeout(function () {
      try {
        var _scrollableViewRef$cu3, _scrollableViewRef$cu4, _scrollableViewRef$cu5;
        var scrollLeft = (_scrollableViewRef$cu3 = scrollableViewRef.current) === null || _scrollableViewRef$cu3 === void 0 ? void 0 : _scrollableViewRef$cu3.scrollLeft;
        var scrollWidth = (_scrollableViewRef$cu4 = scrollableViewRef.current) === null || _scrollableViewRef$cu4 === void 0 ? void 0 : _scrollableViewRef$cu4.scrollWidth;
        var width = (_scrollableViewRef$cu5 = scrollableViewRef.current) === null || _scrollableViewRef$cu5 === void 0 ? void 0 : _scrollableViewRef$cu5.clientWidth;
        setHasPrev(scrollLeft > 0);
        setHasNext(Math.ceil(scrollLeft + width) < scrollWidth);
        if (event !== null && event !== void 0 && event.target) {
          var _event$target;
          onScrollChange === null || onScrollChange === void 0 || onScrollChange((event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.scrollLeft) > scrollLeftValue.current ? 'Right scroll' : 'Left scroll');
        }
        scrollLeftValue.current = scrollLeft;
      } catch (e) {
        console.log(e);
      }
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }, 100);
  };
  var handleClick = function handleClick(event) {
    try {
      // event.target?.scrollIntoView?.({
      //     behavior: 'smooth',
      //     block: 'nearest',
      //     inline: 'center'
      // });
      checkScrollState();
    } catch (e) {}
  };
  var scrollerContextValue = {
    scrollableViewRef: scrollableViewRef,
    scroll: scroll,
    handleClick: handleClick,
    hasNext: hasNext,
    hasPrev: hasPrev
  };
  (0, _react.useEffect)(function () {
    var _scrollableViewRef$cu6, _window;
    checkScrollState();
    (_scrollableViewRef$cu6 = scrollableViewRef.current) === null || _scrollableViewRef$cu6 === void 0 || _scrollableViewRef$cu6.addEventListener('scroll', checkScrollState);
    (_window = window) === null || _window === void 0 || _window.addEventListener('resize', checkScrollState);
    return function () {
      var _scrollableViewRef$cu7, _window2;
      (_scrollableViewRef$cu7 = scrollableViewRef.current) === null || _scrollableViewRef$cu7 === void 0 || _scrollableViewRef$cu7.removeEventListener('scroll', checkScrollState);
      (_window2 = window) === null || _window2 === void 0 || _window2.removeEventListener('resize', checkScrollState);
    };
  }, [scrollableViewRef.current]);
  return /*#__PURE__*/_react["default"].createElement(ScrollerContext.Provider, {
    value: scrollerContextValue,
    "data-sentry-element": "unknown",
    "data-sentry-component": "Scroller",
    "data-sentry-source-file": "index.tsx"
  }, children);
};
Scroller.Box = function (_ref2) {
  var children = _ref2.children;
  var _useContext = (0, _react.useContext)(ScrollerContext),
    scrollableViewRef = _useContext.scrollableViewRef,
    handleClick = _useContext.handleClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sui-scroller",
    onClick: handleClick,
    ref: scrollableViewRef
  }, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    noWrap: true
  }, children));
};
Scroller.Next = function (_ref3) {
  _objectDestructuringEmpty(_ref3);
  var _useContext2 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext2.scroll,
    hasNext = _useContext2.hasNext;
  var styles = (0, _styles2["default"])();
  return /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], _extends({
    timeout: 500
  }, styles.scrollButton, {
    backgroundColor: hasNext ? _colors.Colors.MEDIUM_PURPLE : _colors.Colors.LIGHT_GREY_1,
    hover: hasNext ? {
      backgroundColor: _colors.Colors.NAVY_BLUE_1
    } : {},
    transform: "rotate(-90deg)",
    onClick: hasNext ? function () {
      scroll(1);
    } : null
  }), /*#__PURE__*/_react["default"].createElement(_caret_icon["default"], {
    fill: _colors.Colors.WHITE
  }));
};
Scroller.Prev = function (_ref4) {
  _objectDestructuringEmpty(_ref4);
  var _useContext3 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext3.scroll,
    hasPrev = _useContext3.hasPrev;
  var styles = (0, _styles2["default"])();
  return /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], _extends({
    timeout: 500
  }, styles.scrollButton, {
    backgroundColor: hasPrev ? _colors.Colors.MEDIUM_PURPLE : _colors.Colors.LIGHT_GREY_1,
    hover: hasPrev ? {
      backgroundColor: _colors.Colors.NAVY_BLUE_1
    } : {},
    transform: "rotate(90deg)",
    onClick: hasPrev ? function () {
      scroll(-1);
    } : null
  }), /*#__PURE__*/_react["default"].createElement(_caret_icon["default"], {
    fill: _colors.Colors.WHITE
  }));
};
Scroller.positionedNext = function (_ref5) {
  var children = _ref5.children,
    rest = _objectWithoutProperties(_ref5, _excluded);
  var _useContext4 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext4.scroll,
    hasNext = _useContext4.hasNext;
  var styles = (0, _styles2["default"])();
  if (!hasNext) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, _extends({}, rest, {
    onClick: function onClick() {
      scroll(1);
    }
  }), children);
};
Scroller.positionedPrev = function (_ref6) {
  var children = _ref6.children,
    rest = _objectWithoutProperties(_ref6, _excluded2);
  var _useContext5 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext5.scroll,
    hasPrev = _useContext5.hasPrev;
  var styles = (0, _styles2["default"])();
  if (!hasPrev) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_PositionBox["default"].absolute, _extends({}, rest, {
    onClick: function onClick() {
      scroll(-1);
    }
  }), children);
};
var _default = exports["default"] = Scroller;